// src/hooks/useMemberOptions.js
import { useState, useEffect } from 'react';
import { fetchMemberOptions } from '../api/api';

export function useMemberOptions() {
  const [setterOptions, setSetterOptions] = useState([]);
  const [closerOptions, setCloserOptions] = useState([]);
  const [rookieOptions, setRookieOptions] = useState([]);
  const [veteranOptions, setVeteranOptions] = useState([]);
  const [officeOptions, setOfficeOptions] = useState([]);
  const [allRepOptions, setAllRepOptions] = useState([])

  useEffect(() => {
    fetchMemberOptions()
      .then(data => {
        let setterOpts = []
        let closerOpts = []
        let rookieOpts = []
        let veteranOpts = []
        let officeOpts = []

        data.forEach(tm => {
          if(!officeOpts.includes(tm.office)) {
            officeOpts.push(tm.office)
          }

          tm.title === 'Setter' && setterOpts.push(tm)
          tm.title === 'Closer' && closerOpts.push(tm)
          tm.tenure === 'ROOKIE' && rookieOpts.push(tm)
          tm.tenure === 'VETERAN' && veteranOpts.push(tm)
          tm.tenure === 'SOPHOMORE' && veteranOpts.push(tm)
        })
        officeOpts = officeOpts.sort().map(o => ({label: o}))

        setAllRepOptions(data)
        setSetterOptions(setterOpts)
        setCloserOptions(closerOpts)
        setRookieOptions(rookieOpts)
        setVeteranOptions(veteranOpts)
        setOfficeOptions(officeOpts)
      })
      .catch(console.error);
  }, []);

  return { allRepOptions, setterOptions, closerOptions, veteranOptions, rookieOptions, officeOptions };
}